import { Table } from '../../../components/general/table';
import { useChatAssistantsList } from './hook';
import { ChatAssistantListProps } from './props';

export const ChatAssistantList = ({ filters }: ChatAssistantListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useChatAssistantsList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
        />
    );
};
